module.exports = __webpack_public_path__ + "img/mainDec1_bg_R.2c095f8.webp";